const educationPath = "/api/plt/v1/education";
const questionPath = "/api/plt/v1/question";
const user = "/api/adm/v1/account";
const reward = "/api/plt/v1/reward";
const blog = "/api/plt/v1/blog";
const level = "/api/adm/v1/level";
const product = "/api/plt/v1/product";
const rewardClaim = "/api/plt/v1/reward-claim";
const educationCategory = "/api/plt/v1/education-category";
const cart = "/api/plt/v1/cart";
const promotion = "/api/plt/v1/promotion";
const receipt = "/api/plt/v1/receipt";
const points = "/api/adm/v1/point-record";
const task = "/api/adm/v1/task";
const company = "/api/adm/v1/company";
const country = "/api/adm/v1/country";
const store = "/api/adm/v1/store";
const notification = "api/ntf/v1/app-notification";
const chat = "/api/adm/v1/chat";
const messages = "/api/adm/v1/message";
const lesson = "/api/plt/v1/lesson";

export const updateUser = () => `${user}`;
export const registrationCodeVerify = () => `${user}/verify`;
export const updateUserImage = () => `${user}/change-image`;
export const userLogin = () => `${user}/login`;
export const userInfo = () => `${user}/info`;
export const userLogout = () => `${user}/logout`;
export const userRegistration = () => `${user}/registration`;
export const userSendResetPassword = () => `${user}/send/reset-password`;
export const userResetPassword = () => `${user}/reset-password`;
export const getExpInfoUser = () => `${user}/experience`;
export const changePasswordPath = () => `${user}/change-password`;
export const sendResetPasswordPath = () => `${user}/send/reset-password`;
export const resetPasswordPath = () => `${user}/reset-password`;
export const getRankList = () => `${user}/rank-list`;
export const checkCodeResetPassword = () => `${user}/verify/reset-password`;

export const getRoleList = (id) =>
  id === 0 ? `/api/adm/v1/role` : `/api/adm/v1/role/${id}`;

export const getEducationList = (id) =>
  id === 0 ? `${educationPath}` : `${educationPath}/${id}`;

export const getEducationCatList = (id) =>
  id === 0 ? `${educationPath}` : `${educationPath}/category/${id}`;

export const getEducationArchiveCatList = () => `${educationPath}/archive`;

export const getEducationDetail = (id) => `${educationPath}/${id}`;
export const getStartEducation = (id) => `${educationPath}/start/${id}`;
export const getStartEducationArchive = (id) => `${lesson}/education/${id}`;
export const pathFinishEducation = (data) =>
  `${educationPath}/attempt/${data.status}/${data.educationAttemptId}`;

//edukacija kategorije
export const getEducationCategoryList = () => `${educationCategory}/form`;

export const getQuessAnswer = (questionId, guessAnswerId) =>
  `${questionPath}/guess-answer?questionId=${questionId}&guessAnswerId=${guessAnswerId}`;

//blog
export const getBlogPath = (id) => (id === 0 ? blog : `${blog}/${id}`);

//promotion
export const getPromotionPath = (id) =>
  id === 0 ? promotion : `${promotion}/${id}`;
export const getPromotionCatalogList = (id) =>
  `${product}/catalog/promotion/${id}`;
export const getSearchCatalogList = (search) =>
  `${product}/catalog/search?value=${search}`;

//level
export const getLevelCatalogPath = () => `${level}/reward-catalog`;
export const getLevelGetAllPath = () => `${level}`;

//cart
export const pathAddToCart = () => `${cart}/add`;
export const pathRemoveToCart = () => `${cart}/remove`;
export const getCartList = () => `${cart}`;
export const pathCartItemsCounter = () => `${cart}/size`;

//nagrade
export const getRewardPath = (id) => `${reward}?levelId=${id}`;
export const getUserRewardPath = () => `${rewardClaim}`;
export const getRewardPost = () => `${rewardClaim}`;
export const getRewardListAll = () => `${reward}/level-up`;

//katalog
export const getCatalogPath = (id) =>
  id === "0" ? `${product}/catalog` : `${product}/catalog/${id}`;

//racun
export const putReceipt = () => `${receipt}`;
export const putReceiptDetail = (id) => `${receipt}/${id}`;
export const getOrderPath = (status) => `${receipt}?status=${status}`;

//poeni
export const getPointsPath = () => `${points}`;
export const getReamingPointsPath = () => `${points}/remaining`;

//taskovi
export const getTaskDetailPath = (id) => `${task}/${id}`;
export const getTaskPath = (type) => `${task}/${type}`;

export const getCountryFormList = (id) => `${country}/form`;
export const getCompanyFormList = (id) => `${company}/form?countryId=${id}`;
export const getStoreFormList = (id) => `${store}/form?companyId=${id}`;

export const getNewNotifications = () => `${notification}/new`;
export const getNotifications = (page) => `${notification}?pageable=${page}`;

export const getChatPath = () => `${chat}`;
export const getChatSendPath = () => `${messages}`;
export const getMessagesList = (id, page, size) =>
  `${messages}/${id}?page=${page}&size=${size}`;
